import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import { canAccessDataprevFeatures } from "../../utils/dataprevAccess";

interface Props {
  element?: any;
  path?: string;
}

export const SimulationFinancialsRoute: FC<Props> = () => {
  const { userLogged } = useAuth();

  if (!canAccessDataprevFeatures(userLogged?.partner_code)) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};
